import { ShowDetailsButton } from '../../../buttons/ShowDetailsButton';
import type { StandardButtonProps } from '../../../buttons/StandardButton';

type Props = {
  hideButton?: boolean;
} & StandardButtonProps;

export default ({ hideButton, ...rest }: Props) => {
  if (hideButton) {
    return null;
  }

  return (
    <ShowDetailsButton
      size="small"
      data-testid="dialog-open-button"
      {...rest}
    />
  );
};
